import React, { useEffect, useMemo, useRef } from 'react';
import { Container, Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { gameDrawer } from '../../../../services/gameDrawer';
import { gameResourcesService } from '../../../../services/gameResourcesService';

import { isMobile } from '../../../../core/helpers/isMobile';

import TextOrderingByWidth from '../../textOrderingByWidth';
import { isoStandard } from '../../../../core/helpers/isoStandard';
import { applicationStore } from '../../../../store/applicationStore';
import { winBarStore } from '../../../../store/winBarStore';
import { getGameImages } from '../../../../core/helpers/getGameImages';

const WinLineComponent = observer(
  ({
    allWinLines,
    isVisible,
    amountValue,
    currencySymbol,
    backGroundTexture,
    canvasTranslationKeys,
    hasBackGround = true,
    x = 0,
    y = 0,
  }) => {
    const winAmountTextureRef = useRef();
    const { isShowLicenseMode, isDemo } = applicationStore;
    const { winLine } = winBarStore;
    const images = useMemo(() => {
      return getGameImages();
    }, []);

    const currentWinLine = useMemo(() => {
      if (!allWinLines) {
        return null;
      }
      return allWinLines.find((item) => item.line === winLine);
    }, [allWinLines, winLine]);

    const texts = useMemo(() => {
      return [
        {
          id: 0,
          text: !currentWinLine?.line
            ? `${canvasTranslationKeys.SCATTER}`
            : `${canvasTranslationKeys.LINE} ${currentWinLine?.line}:`,
          style: { fill: '#FFC33E', _fontWeight: 700, _fontSize: isMobile() ? 14 : 12 },
          ref: null,
        },
        {
          id: 1,
          text: isoStandard(currentWinLine?.lineWinAmount, true),
          style: { fill: '#FFFFFF', _fontWeight: 700, _fontSize: isMobile() ? 16 : 14 },
          ref: winAmountTextureRef,
          x: 40,
        },
        {
          id: 2,
          text: currencySymbol,
          style: { fill: '#FFFFFF', _fontWeight: 700, _fontSize: isMobile() ? 16 : 14 },
          ref: null,
          x: 40,
        },
      ];
    }, [canvasTranslationKeys.LINE, currentWinLine, currencySymbol]);

    const updateTextByLicense = useMemo(() => {
      return isShowLicenseMode && !isDemo ? [texts[0], texts[2], texts[1]] : texts;
    }, [isShowLicenseMode, isDemo, texts]);

    useEffect(() => {
      if (winAmountTextureRef.current) {
        gameResourcesService.setWinAmountTexture(winAmountTextureRef.current);
        gameDrawer.animateWinAmount({ value: amountValue });
      }
    }, [winAmountTextureRef, amountValue]);

    if (!currentWinLine) {
      return null;
    }

    return (
      <Container name='WinAmountContainer' visible={isVisible} x={x} y={y}>
        {hasBackGround && (
          <Sprite anchor={0.5} scale={isMobile() ? 0.77 : 0.5} texture={backGroundTexture} />
        )}
        <TextOrderingByWidth
          texts={updateTextByLicense}
          InnerComp={({ xInner }) => {
            return (
              <Container x={5}>
                {new Array(currentWinLine.count).fill(null).map((el, index) => (
                  <Sprite
                    key={'item'.concat(`${index}`)}
                    x={xInner + 24 * index}
                    anchor={0.5}
                    scale={isMobile() ? 0.77 : 0.5}
                    texture={images[`symbol${currentWinLine.symbol}`]}
                  />
                ))}
              </Container>
            );
          }}
          innerWidth={24 * currentWinLine.count}
          innerCompIndex={1}
        />
      </Container>
    );
  }
);

export default WinLineComponent;
